var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item"},[_c('div',{staticClass:"nav-link clickable",on:{"click":_vm.logout}},[_c('p',[_vm._v("Log Out")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }